import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";

export class PiggyAnimationPromiseHolder {
    private pcs: PromiseCompletionSource<void>;

    public get promise(): Promise<void> {
        return this.pcs?.result;
    }

    public start(): void {
        this.pcs = new PromiseCompletionSource<void>();
    }

    public complete(): void {
        this.pcs?.complete();
    }

    public reset(): void {
        this.pcs = null;
    }
}